import React from "react";
import { assets } from "../../Assets/assets";

const ApplicationDownload = () => {
  return (
    <div className="w-full px-4 md:px-8 py-8">
      <div className="2xl:max-w-7xl mx-auto">

        {/* MAIN CARD */}
        <div className="relative bg-gradient-to-b from-[#FFEDF2] to-[#FFFFFF00] rounded-[30px] overflow-hidden pl-2 pt-16 md:pl-12 flex flex-col md:flex-row items-center">

          {/* LEFT CONTENT */}
          <div className="w-full md:w-1/2 z-10 space-y-5">

            {/* HEADING */}
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-semibold bg-clip-text text-transparent bg-gradient-to-r from-[#3D0F1B] to-subPrimaryColor leading-tight">
              Trade from anywhere.
            </h2>

            {/* DESCRIPTION */}
            <p className="text-sm md:text-base text-gray-600 lg:max-w-md leading-relaxed">
              The Best Platform For B2B Business Growth And Global Trade Opportunities.
              Create Your Requirements Here And Wait For The Best Quotation
            </p>

            {/* DOWNLOAD CARD */}
            <div className="bg-white rounded-2xl p-4 flex items-center gap-4 w-fit shadow-sm">

              {/* PLAY STORE */}
              <div className="flex flex-col items-start">
                <a href="https://play.google.com/store/apps/details?id=com.pcmexports" target="_blank" rel="noopener noreferrer">
                  <img
                    src={assets.playstore}
                    alt="playstore"
                    className="w-36 mb-2"
                  />
                </a>
                <p className="text-xs text-gray-500">Scan To Download</p>
              </div>

              {/* QR */}
              <img
                src={assets.qr}
                alt="qr"
                className="w-20 h-20 object-contain"
              />
            </div>

          </div>

          {/* RIGHT IMAGE */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end mt-10 md:mt-0 relative">

            <img
              src={assets.downloadhand}
              alt="mobile"
              className="w-full md:w-[320px] lg:w-[380px] object-contain md:translate-x-10"
            />

          </div>

        </div>

      </div>
    </div>
  );
};

export default ApplicationDownload;